export default __webpack_public_path__ + "static/case-3-e55a8839f2cdeaf2c3c6cc697adf8f7c.png";